import React, { useState } from "react";
import Logo from "../Logo/Logo";
import appStoreBadge from "../../assets/download-on-the-app-store-badge.png";
import googlePlayBadge from "../../assets/get-it-on-google-play-badge.png";
import { Link } from "react-router-dom";

const LandingPageNew = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Mobile menu toggle
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div
      className="antialiased"
      style={{
        fontFamily: "Inter, sans-serif",
        backgroundColor: "#FDFCFB",
        color: "#333333",
      }}
    >
      {/* Custom styles */}
      <style>{`
        html {
          scroll-behavior: smooth;
        }
        .step-item:before {
          content: '';
          position: absolute;
          left: 1.25rem;
          top: 2.5rem;
          bottom: -2.5rem;
          width: 2px;
          background-color: #b3e7e7;
          transform: translateX(-50%);
        }
        .step-item:last-child:before {
          display: none;
        }
        .faq-item summary::-webkit-details-marker {
          display: none;
        }
        .faq-item[open] .faq-icon {
          transform: rotate(45deg);
        }
        .faq-icon {
          display: inline-block;
          transition: transform 0.2s;
          line-height: 1;
        }
      `}</style>

      {/* Header & Navigation */}
      <header className="bg-white/80 backdrop-blur-sm sticky top-0 z-50 shadow-sm">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex">
            <Logo />
          </div>
          <div className="hidden md:flex space-x-6 items-center">
            <a
              href="#sta-je"
              className="!text-gray-600 hover:!text-teal-700 transition"
            >
              O nama
            </a>
            <a
              href="#pomoc-pri-preuzimanju"
              className="!text-gray-600 hover:!text-teal-700 transition"
            >
              Pomoć pri preuzimanju
            </a>
            <a
              href="#pitanja"
              className="!text-gray-600 hover:!text-teal-700 transition"
            >
              Pitanja
            </a>
            <a
              href="#preuzmite"
              className="!bg-teal-600 !text-white px-4 py-2 rounded-lg hover:!bg-teal-700 transition-colors"
            >
              Preuzmite aplikaciju
            </a>
          </div>
          <button
            onClick={toggleMobileMenu}
            className="md:hidden text-gray-700"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </nav>
        {mobileMenuOpen && (
          <div className="md:hidden bg-white px-6 pb-4">
            <a
              href="#sta-je"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 !text-gray-600 hover:!text-teal-700"
            >
              O nama
            </a>
            <a
              href="#pomoc-pri-preuzimanju"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 !text-gray-600 hover:!text-teal-700"
            >
              Pomoć pri preuzimanju
            </a>
            <a
              href="#pitanja"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 !text-gray-600 hover:!text-teal-700"
            >
              Pitanja
            </a>
            <a
              href="#preuzmite"
              onClick={() => setMobileMenuOpen(false)}
              className="block mt-2 text-center !bg-teal-600 !text-white px-4 py-2 rounded-lg hover:!bg-teal-700"
            >
              Preuzmite aplikaciju
            </a>
          </div>
        )}
      </header>

      <main>
        {/* What Is Section */}
        <section id="sta-je" className="pt-24 pb-20 md:pt-32">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Šta je apoteka.rs?
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                apoteka.rs je platforma koja Vas povezuje sa farmaceutima,
                lekarima i apotekama. Preko aplikacije možete da pitate
                farmaceuta, da rezervišete proizvode iz apoteke koju sami
                izaberete i da ih preuzmete kada Vam odgovara. Lek uvek izdaje
                farmaceut u apoteci. Ako ne možete sami do apoteke, članovi
                udruženja Zdravo svima mogu Vam pomoći pri preuzimanju
                rezervacije u Vaše ime.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow border border-gray-100">
                <div className="text-4xl text-teal-600 mb-4">
                  <span role="img" aria-label="Razgovor">
                    💬
                  </span>
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Pitaj farmaceuta
                </h3>
                <p className="text-gray-600">
                  Licencirani farmaceut iz partnerske apoteke dostupan Vam je
                  porukom, pozivom ili video pozivom. Svaki razgovor vodi
                  imenovani farmaceut u ime svoje apoteke.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow border border-gray-100">
                <div className="text-4xl text-teal-600 mb-4">
                  <span role="img" aria-label="Apoteka">
                    🏥
                  </span>
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Rezervišite u apoteci koju izaberete
                </h3>
                <p className="text-gray-600">
                  Lekove po receptu i druge proizvode rezervišete u apoteci po
                  svom izboru. Farmaceut proverava recept i raspoloživost i
                  potvrđuje rezervaciju. Plaćate u apoteci, prilikom
                  preuzimanja.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow border border-gray-100">
                <div className="text-4xl text-teal-600 mb-4">
                  <span role="img" aria-label="Pomoć">
                    🤝
                  </span>
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Pomoć pri preuzimanju rezervacije
                </h3>
                <p className="text-gray-600">
                  Ako ne možete sami do apoteke, član udruženja Zdravo svima
                  može Vam pomoći prilikom preuzimanja rezervacije u Vaše ime,
                  na osnovu ovlašćenja koje mu Vi date, i predati Vam je na
                  mestu koje odredite. Pomoć je besplatna i zavisi od
                  raspoloživosti ovlašćenih lica.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Pickup Assistance Section */}
        <section id="pomoc-pri-preuzimanju" className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Pomoć pri preuzimanju rezervacije
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Program vodi Udruženje "Zdravo svima". Namenjen je članovima
                udruženja kojima je otežan odlazak do apoteke: starijim i
                hronično obolelim osobama, osobama sa ograničenom
                pokretljivošću, roditeljima male dece, kao i svim građanima
                kojima je ovakva pomoć neophodna.
              </p>
            </div>

            <h3 className="text-2xl font-bold text-gray-800 text-center mb-10">
              Kako funkcioniše
            </h3>
            <div className="relative max-w-2xl mx-auto mb-20">
              {[
                "Kreirajte rezervaciju u apoteci koju izaberete. Farmaceut potvrđuje rezervaciju.",
                "Podnesete zahtev za pomoć pri preuzimanju. Koordinator udruženja predlaže Vam ovlašćeno lice, proverenog člana ili volontera udruženja. Vi ga potvrđujete.",
                "Dajete ovlašćenom licu ovlašćenje da u Vaše ime i za Vaš račun preuzme tačno tu rezervaciju. Ovlašćenje važi samo za to preuzimanje.",
                "Farmaceut u apoteci proverava recept i ovlašćenje i izdaje lek. Lek se plaća u apoteci, Vašim sredstvima.",
                "Lice koje ste Vi ovlastili lično Vam predaje rezervaciju na mestu koje ste odredili.",
              ].map((text, index, steps) => (
                <div
                  key={index}
                  className={`step-item relative pl-16 ${
                    index === steps.length - 1 ? "" : "pb-12"
                  }`}
                >
                  <div className="absolute left-0 top-0 flex items-center justify-center w-10 h-10 rounded-full bg-teal-600 text-white font-bold text-xl">
                    {index + 1}
                  </div>
                  <p className="text-gray-700 text-lg pt-1">{text}</p>
                </div>
              ))}
            </div>

            <h3 className="text-2xl font-bold text-gray-800 text-center mb-10">
              Šta treba da znate
            </h3>
            <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                <p className="text-gray-700">
                  Pomoć je besplatna. Ovlašćena lica ne primaju naknadu. Udruženje
                  snosi troškove programa iz članarine i donacija.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                <p className="text-gray-700">
                  O izdavanju leka uvek odlučuje farmaceut. Ovlašćeno lice ne može da
                  preuzme ništa bez Vašeg ovlašćenja i važećeg recepta.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                <p className="text-gray-700">
                  Pomoć zavisi od raspoloživosti ovlašćenih lica u Vašem kraju. Ne
                  garantujemo rok.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                <p className="text-gray-700">
                  Platformu apoteka.rs, koju koristimo za komunikaciju i
                  evidenciju, održava Extra Care Group d.o.o. Platforma ne
                  izdaje, ne naplaćuje i ne prenosi lekove.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section id="pitanja" className="py-20">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Najčešća pitanja
              </h2>
            </div>
            <div className="max-w-3xl mx-auto space-y-4">
              {[
                {
                  q: "Da li apoteka.rs dostavlja lekove?",
                  a: "Ne. Lekove izdaje farmaceut u apoteci. Ako ne možete sami do apoteke, član udruženja Zdravo svima Vam može, uz Vaše ovlašćenje, pomoći prilikom preuzimanja rezervacije i predati Vam je.",
                },
                {
                  q: "Ko je lice koje ste Vi ovlastili?",
                  a: "Član ili volonter udruženja Zdravo svima, kojeg je udruženje proverilo i upoznalo sa pravilima programa. Ovlašćeno lice Vam predlaže koordinator udruženja.",
                },
                {
                  q: "Koliko košta pomoć?",
                  a: "Ništa. Pomoć je besplatna za članove udruženja. Plaćate samo lek, u apoteci.",
                },
                {
                  q: "Kako plaćam lek ako ga preuzima lice koje sam ja ovlastio?",
                  a: "Sredstva za lek predajete licu koje ste Vi ovlastili ili plaćate apoteci na način koji apoteka omogućava. Račun apoteke glasi na Vas.",
                },
                {
                  q: "Mogu li da rezervišem lek na recept?",
                  a: "Da, uz važeći eRecept. Farmaceut proverava recept pre potvrde rezervacije.",
                },
                {
                  q: "Mogu li da platim lek online?",
                  a: "Ne. Lekovi se plaćaju u apoteci prilikom izdavanja. Online plaćanje moguće je samo za proizvode koji nisu lekovi.",
                },
                {
                  q: "Ko vidi moje podatke?",
                  a: "Apoteka koju ste izabrali, farmaceut sa kojim razgovarate i, ako zatražite pomoć, koordinator udruženja i lice koje ste Vi ovlastili, u obimu potrebnom za preuzimanje.",
                },
              ].map((item) => (
                <details
                  key={item.q}
                  className="faq-item bg-white rounded-xl shadow-md border border-gray-100 px-6 py-4"
                >
                  <summary className="cursor-pointer text-lg font-semibold text-gray-800 list-none flex justify-between items-center">
                    <span>{item.q}</span>
                    <span className="faq-icon text-teal-600 text-2xl ml-4">
                      +
                    </span>
                  </summary>
                  <p className="text-gray-600 mt-3">{item.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section id="preuzmite" className="py-20 bg-teal-700 text-white">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Spremni za lakši život?
            </h2>
            <p className="text-lg md:text-xl max-w-2xl mx-auto mb-8 text-teal-100">
              Preuzmite aplikaciju apoteka.rs danas i iskusite budućnost
              farmaceutske nege. Briga o zdravlju nikada nije bila
              jednostavnija.
            </p>
            <div className="flex justify-center space-x-4">
              <a
                href="https://apps.apple.com/rs/app/apoteka-rs/id1642092872"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-transform hover:scale-105"
              >
                <img
                  src={appStoreBadge}
                  alt="Download on the App Store"
                  className="h-12"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=rs.apoteka"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-transform hover:scale-105"
              >
                <img
                  src={googlePlayBadge}
                  alt="Get it on Google Play"
                  className="h-12"
                />
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-gray-300 py-12">
        <div className="container mx-auto px-6 text-center">
          <p>
            &copy; {new Date().getFullYear()} apoteka.rs | Sva prava zadržana.
          </p>
          <p className="text-sm mt-2">
            Za dodatne informacije pozovite nas besplatno na broj:{" "}
            <a href="tel:0800800700" className="!text-teal-400 hover:underline">
              0800 800 700
            </a>
          </p>
          <div className="flex gap-4 justify-center text-sm mt-2">
            <Link
              to="/PrivacyPolicy"
              onClick={() => window.scrollTo(0, 0)}
              className="!text-teal-400 hover:underline"
            >
              Izjava o privatnosti
            </Link>
            <Link
              to="/TermsOfService"
              onClick={() => window.scrollTo(0, 0)}
              className="!text-teal-400 hover:underline"
            >
              Opšti uslovi korišćenja
            </Link>
            <Link
              to="/misljenje-ministarstva-zdravlja"
              onClick={() => window.scrollTo(0, 0)}
              className="!text-teal-400 hover:underline"
            >
              Mišljenje Ministarstva zdravlja
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPageNew;
